export const environment = {
  production: true,
  baseAddress: ''
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts